import { InquiryBox } from "@/components/inquiry/InquiryBox";
import { cn } from "@/lib/utils";

export const PageShell = ({ hero, children, overlap = "page", aside, asideFirstOnMobile = true }) => (
  <>
    {hero}
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_400px] lg:gap-12">
        <main id="inhalt" className={cn("min-w-0 pb-16 lg:py-16", !asideFirstOnMobile && "pt-10")} data-testid="page-main">
          {children}
        </main>
        <aside
          id="anfrage"
          className={cn(
            "relative z-20 lg:order-none",
            asideFirstOnMobile ? "order-first -mt-8" : "pb-16 lg:pb-0",
            overlap === "home" ? "lg:-mt-[340px]" : "lg:-mt-[240px]",
          )}
        >
          <div className="lg:sticky lg:top-28">{aside || <InquiryBox />}</div>
        </aside>
      </div>
    </div>
  </>
);
